import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'user', label: 'Student', sortable: true },
    { key: 'dc_type', label: 'Dc Type', sortable: true },
    { key: 'direction', label: 'Direction', sortable: true },
    { key: 'edu_lang', label: 'Education Language', sortable: true },
    { key: 'quarter', label: 'Quarter', sortable: true },
    { key: 'advisor', label: 'Research Advisor', sortable: true },
    { key: 'user.mob_phone_no', label: 'Phone', sortable: true },
    { key: 'user.pin', label: 'PNFL', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'state', label: 'Himoya holati', sortable: true },
    {
      key: 'actions',
      label: 'Actions',
      thClass: 'student-list-actions-column',
      tdClass: 'student-list-actions-column',
    },
  ]

  return {
    tableColumns,
    ...tableConfig('student'),
  }
}
